import { h } from 'preact'; /** @jsx h */

import './FixedCTA.scss';

const FixedCTA = ({
    color = 'snla-red',
    text = '<b>1 av 3</b><br /> ringer ikke 113 først',
    buttonText = 'Last ned<br /><b>Hjelp 113</b>',
    icon = 'https://norskluftambulanse.no/wp-content/uploads/2024/09/hjelp-113-app-icon.png',
    link = '/stott-oss/',
    target = '_self'
}) => {
    return (
        <a className={`fixed-cta color-${color}`} href={link} target={target}>
            <div className="fixed-cta-icon"></div>
            <div className="fixed-cta-content">
                <div className="fixed-cta-text" dangerouslySetInnerHTML={{ __html: text }} />
                <div className="divider" />
                <div className="fixed-cta-link">
                    <span dangerouslySetInnerHTML={{ __html: buttonText }} />
                    <img src={icon} alt className="fixed-cta-icon" loading="lazy" />
                </div>
            </div>
        </a>
    );
};

export default FixedCTA;
